import { PresetDeleteActionDialog } from '@aibees/elephant/components/preset-delete-action-dialog';
import { Icon } from '@aibees/shared/components';
import { useBoolean, useQueryStringState } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SortableActionProps as Props } from './types';

export const SortableAction = memo(
  ({
    className,
    item,
    createDialogState,
    openingDialogState,
    presetTitle,
    beforeEditAction,
    beforeDuplicateAction,
  }: Props) => {
    const { setParams } = useQueryStringState();
    const deleteState = useBoolean();

    const handleEditDialog = () => {
      beforeEditAction();
      setParams(item.value.value as Record<string, any>);
      createDialogState?.onTrue();
      openingDialogState?.onFalse();
    };

    const handleDeleteDialog = () => {
      deleteState?.onTrue();
    };

    const handleDuplicate = () => {
      beforeDuplicateAction();
      setParams(item.value.value as Record<string, any>);
      createDialogState?.onTrue();
      openingDialogState?.onFalse();
    };

    return (
      <>
        <PresetDeleteActionDialog
          state={deleteState}
          item={item}
          presetTitle={presetTitle}
        />

        <Styled.Wrapper
          className={classnames('SortableAction', className)}
          sx={SX.root}
        >
          <Tooltip title="Clone Buying Team" placement="left">
            <Icon
              name="copy-all-outline"
              sxx={SX.icon}
              onClick={handleDuplicate}
            />
          </Tooltip>
          {item.user.id !== 'system' && (
            // TODO: this condition is based on fake data and should be reconsidered after taking care of sample teams
            <Icon name="delete" sxx={SX.icon} onClick={handleDeleteDialog} />
          )}
          <Icon name="edit" sxx={SX.icon} onClick={handleEditDialog} />
        </Styled.Wrapper>
      </>
    );
  }
);

SortableAction.displayName = 'SortableAction';
